import { Box, Flex, Menu, Switch, MenuItem, MenuList, MenuButton } from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

import {
  FetchPlannerModeBlock,
  FetchPlannerModeModel,
  getPlannerBlock,
} from 'redux/PlannerModeSlice';
import { getBlockDetails } from 'redux/PlanPageSlice';
import DimensionTabIcon from 'components/Icons/ModelOverviewTabs/DimensionTabIcon';

const MultiDimSetting = () => {
  const { blockId, modelId } = useParams();
  const dispatch: any = useDispatch();
  const dimensionList = useSelector(getBlockDetails);
  const [dimensionData, setDimensionData] = useState(dimensionList?.dimensions || []);

  const plannerBlock = useSelector(getPlannerBlock);
  //   const navigate = useNavigate();

  useEffect(() => {
    if (modelId) {
      dispatch(FetchPlannerModeModel(Number(modelId)));
      dispatch(FetchPlannerModeBlock(Number(blockId)));
    }
  }, [modelId, blockId]);

  useEffect(() => {
    const dimensionsList = dimensionList?.dimensions;
    setDimensionData(dimensionsList);
  }, [dimensionList?.dimensions]);

  //   const doesDimensionExist = (dim: any, dimArray: any[]) =>
  //     dimArray.some((data) => data?.id === dim?.id);

  const renderMenuList = (list: any) => {
    const filteredList: any = [...(list || [])];
    return (
      <Box maxH={'190px'} overflowY={'auto'} className='scroll'>
        {filteredList?.map((data: any, index: number) => (
          <MenuItem key={index} padding={'.5rem 0'} as={'li'}>
            <Switch mr={2} disabled={data?.name === 'time' || data?.name === 'Time'}></Switch>
            {data?.name}
          </MenuItem>
        ))}
      </Box>
    );
  };

  //   const redirectToDimension = () => {
  //     navigate(`/model/${modelId}/home`);
  //     dispatch(handleBuilderModeTab(1));
  //   };

  return (
    <Flex alignItems={'center'}>
      <Menu closeOnSelect={false} variant={'primary'}>
        <MenuButton
          pl={2}
          pr={3}
          py={2}
          color={'white'}
          fontSize={'14px'}
          transition='all 0.2s'
          borderWidth='1px'
        >
          <DimensionTabIcon color='#4BB6B9' /> ({plannerBlock?.dimensions?.length} /
          {dimensionData.length}) <ChevronDownIcon />
        </MenuButton>
        <MenuList w={'230px'} pb={0} px={4} maxH={'250px'}>
          {renderMenuList(dimensionData)}
          {/* <Divider color={'#dfdfdf'} mt={2} />
          <Button
            fontSize={'xs'}
            px={0}
            pt={3}
            pb={2}
            variant={'primary'}
            onClick={() => redirectToDimension()}
          >
            Edit dimensions
          </Button> */}
        </MenuList>
      </Menu>
    </Flex>
  );
};

export default MultiDimSetting;
